<template>
  <div style="height: 100%;">
    <span class="mdi mdi-spin mdi-loading mdi-48px" v-if="isLoading"></span>
    <table class="table-box disp-scroll" v-if="!isLoading && !selectedTemplate">
      <tr>
        <th style="width: 100%;" class="table-th">シート名</th>
      </tr>
      <tr v-for="template in sheetTemplates" :key="template.id">
        <td class="clickable" @click="selectTemplate(template)">{{template.name}}</td>
      </tr>
    </table>
    <div style="height: 100%;" v-if="!isLoading && selectedTemplate">
      <div style="font-size: 1.2em; font-weight: bold; padding: 4px; display: flex;">
        <span>{{selectedTemplate.name}}</span>
        <button class="button is-small" style="margin-left:auto; margin-right: 8px;" @click="outputPDF()">PDF出力</button>
      </div>
      <div style="height: calc(100% - 40px);" class="disp-scroll">
        <table class="table-box">
          <tr>
            <th style="width: 30%;" class="table-th">
              項目
            </th>
            <th style="width: 70%;" class="table-th">
              内容
            </th>
          </tr>
          <tr v-for="column in sheetColumns" :key="column.id">
            <td style="width: 30%;">{{column.name}}</td>
            <td class="line-feed" style="width: 70%;" v-if="column.refer_column == null">
              <textarea class="textarea is-small cell-textbox disp-scroll" v-model="freeInputs[column.id]"></textarea>
            </td>
            <td class="line-feed" style="width: 70%;" v-else-if="isCustomColumn(column)">
              <template v-if="hasCustomColumnValue(seeker, column)">
                <template v-if="!isPulldownColumn(column).isPulldown && isPulldownColumn(column).type_for_custom_column != 3">
                  <textarea
                    v-if="isPulldownColumn(column).is_multiline"
                    class="textarea is-small cell-textbox disp-scroll"
                    :value="customColumnContent(seeker, column)"
                    @input="handleCustomColumnChange(seeker, column, $event.target.value)"
                  ></textarea>
                  <input
                    v-else
                    class="input is-small cell-textbox"
                    :value="customColumnContent(seeker, column)"
                    @input="handleCustomColumnChange(seeker, column, $event.target.value)"
                  />
                </template>
                <select
                  v-else-if="isPulldownColumn(column).isPulldown"
                  :key="column.id + '-col27'"
                  class="select"
                  v-model="column.content"
                  @change="handleCustomColumnChange(seeker, column, $event.target.value)"
                >
                  <option value="">選択してください</option>
                  <option
                    v-for="option in getOptionsForColumn(column.refer_column)"
                    :value="option.name"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <template v-else-if="!isPulldownColumn(column).isPulldown && isPulldownColumn(column).type_for_custom_column == 3">
                  <input
                    type="date"
                    class="input is-small"
                    :value="customColumnContent(seeker, column)"
                    @change="handleCustomColumnChange(seeker, column, $event.target.value)"
                    :key="column.id + '-col27'"
                  />
                </template>
              </template>
              <template v-else>
                <button
                  class="button is-small"
                  style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;"
                  @click="handleCreateCustomColumn(seeker, column)"
                  v-if="!isPulldownColumn(column).isPulldown && !hasCustomColumnValue(seeker, column) && isPulldownColumn(column).type_for_custom_column != 3"
                >
                  + 作成
                </button>
                <select
                  :key="column.id + '-col27'"
                  v-else-if="isPulldownColumn(column).isPulldown && !hasCustomColumnValue(seeker, column)"
                  class="select"
                  v-model="column.content"
                  @change="handleSelectChange($event, seeker, { pk: column.refer_column, name: column.name })"
                >
                  <option value=""  disabled selected>選択してください</option>
                  <option
                    v-for="option in getOptionsForColumn(column.refer_column)"
                    :value="option.name"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <template v-else-if="isPulldownColumn(column).type_for_custom_column === 3 && !hasCustomColumnValue(seeker, column)">
                  <input
                    type="date"
                    @change="handleSelectChange($event, seeker, { pk: column.refer_column, name: column.name })"
                  />
                </template>
              </template>
            </td>
            <td class="line-feed" style="width: 70%;" v-else>{{getContent(column)}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    seeker: {
      type: Object,
      required: true
    },
    sexTypes: {
      type: Array,
      required: true
    },
    progressOptions: {
      type: Array,
      required: true
    },
    getInterviewDate: {
      type: Function,
      required: true
    },
    getMediaName: {
      type: Function,
      required: true
    },
    updateCustomColumnByCell: {
      type: Function,
      required: true
    },
    pulldownOptionsByColumnId: {
      type: Object,
      required: true
    },
    getOptionsForColumn: {
      type: Function,
      required: true
    },
    createCustomColumn: {
      type: Function,
      required: true
    },
    isColInSkInfo: {
      type: Function,
      required: true
    },
    handleSelectChange: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      sheetTemplates: [],
      sheetColumns: [],
      selectedTemplate: undefined,
      isLoading: false,
      localColumnValues: {},
      selectedValue: {},
      mapColumnTypeToSeekerAttribute: {
        1: seeker => seeker.recruit_route || this.getMediaName(seeker),
        2: seeker => seeker.name,
        3: seeker => seeker.name_phonetic,
        4: seeker => seeker.email,
        5: seeker => seeker.tel,
        6: seeker => seeker.birth ? moment(new Date(seeker.birth)).format('YYYY/MM/DD') : '設定なし',
        7: seeker => seeker.address,
        8: seeker => seeker.seeker_files.map((file)=>file.name).join('\n'),
        9: seeker => this.sexTypes[seeker.sex],
        10: seeker => this.progressOptions.find((po)=>po.value==seeker.progress_rate).text,
        11: seeker => seeker.subscribe_date ? moment(new Date(seeker.subscribe_date)).format('YYYY/MM/DD(dd)') : '',
        12: seeker => seeker.subscribe_count,
        13: seeker => seeker.message,
        14: seeker => seeker.career.map((ca)=>ca.career_year+'年 '+ca.career_month+'月\t\t'+ca.career_body).join('\n'),
        15: seeker => seeker.qualification.map((qf)=>qf.qualification_year+'年 '+qf.qualification_month+'月\t\t'+qf.qualification_body).join('\n'),
        16: seeker => seeker.scout_mail_flg ? '送付済み' : '',
        17: seeker => seeker.job_offer_no,
        // 18: 外部媒体
        19: seeker => this.recruitmentFlows[0].stages.find((stage)=>stage.pk==seeker.recruitment_flow_stage).name,
        20: seeker => this.recruitmentFlows[0].stages.find((stage)=>stage.pk==seeker.recruitment_flow_stage).status.find((stat)=>stat.pk==seeker.recruitment_flow_status).name,
        21: seeker => seeker.recruitment_flow_action_history.at(-1).action_data.name,
        22: seeker => this.getInterviewDate(seeker.interview_history),
        // 23: 回答履歴
        // 24: フラグ
      },
      existingContents: {},
      freeInputs: [],
    }
  },
  computed: {
    ...mapState('auth', ['recruitmentFlows', 'companyColumnSetting']),
    customColumnContent() {
      return (seeker, column) => {
        const customColumn = seeker.custom_column.find(c => c.column === column.refer_column);
        return customColumn ? customColumn.content : '';
      };
    },
  },
  mounted () {
    this.isLoading = true
    this.$store.dispatch('auth/getDetailSheetTemplateList')
    .then((d) => {
      this.sheetTemplates = d.data
      this.isLoading = false
    })
  },
  methods: {
    adaptedIsColInSkInfo(seeker, column) {
      // column.pk が存在しない場合、refer_column を使用
      const columnId = column.pk || column.refer_column;
      return this.isColInSkInfo(seeker, { pk: columnId });
    },
    hasCustomColumnValue(seeker, column) {

      if (!this.isColInSkInfo) {
        console.warn('isColInSkInfo is not provided');
        return false;
      }

      const hasColumn = this.adaptedIsColInSkInfo(seeker, column);
      const customColumn = seeker.custom_column.find(c => c.column === column.refer_column);
      const hasContent = customColumn && customColumn.content && customColumn.content.trim() !== '';

      console.log('HasColumn:', hasColumn, 'HasContent:', hasContent);

      return hasColumn || hasContent; // OR 演算子を使用
    },

    handleCreateCustomColumn(seeker, column) {

      const createCustom = {
        name: column.name,
        type: 0,
        content: '',
        select_list: '',
        column: column.refer_column, // ここを column.refer_column に変更
        id: seeker.id
      };

      // 親コンポーネントの期待する形式に合わせる
      const parentCustom = {
        ...createCustom,
        pk: createCustom.column // column を pk に変更
      };

      this.createCustomColumn(seeker, parentCustom);

    },

    getColumnValue(seeker, column) {
      return this.localColumnValues[`${seeker.id}-${column.refer_column}`] || '';
    },

    isCustomColumn(column) {
      const manageColumn = this.companyColumnSetting.find(s => s.pk === column.refer_column);
      return manageColumn && manageColumn.template_type === 0;
    },

    async handleCustomColumnChange(seeker, column, newValue) {
      const customColumn = seeker.custom_column.find(c => c.column === column.refer_column);

      try {
        const updateData = customColumn
          ? { ...customColumn, content: newValue }
          : {
              column: column.refer_column,
              content: newValue,
              name: column.name,
              id: seeker.id,
              pk: customColumn ? customColumn.pk : null,
              type: customColumn ? customColumn.type : 0,
              select_list: customColumn ? customColumn.select_list : ''
            };

        await this.updateCustomColumnByCell(seeker, updateData);

        // 更新が成功したら、ローカルのデータも更新
        column.content = newValue;

        // seeker.custom_column も更新
        if (customColumn) {
          customColumn.content = newValue;
        } else {
          seeker.custom_column.push({
            column: column.refer_column,
            content: newValue,
            name: column.name
          });
        }

      } catch (error) {
        console.error('カスタムカラムの更新中にエラーが発生しました:', error);
        // エラーメッセージをユーザーに表示するなどの処理
      }
    },
    selectTemplate (template) {
      this.selectedTemplate = template
      if (this.selectedTemplate) {
        this.loadSheet()
      }
    },
    loadSheet() {
      this.isLoading = true
      let p1 = this.$store.dispatch('auth/getDetailSheetColumnList', this.selectedTemplate.id)
      let p2 = this.$store.dispatch('directtalk/getDetailSheetContents', {seeker_id: this.seeker.id, template_id: this.selectedTemplate.id})
      Promise.all([p1, p2])
      .then(([d1, d2]) => {
        this.sheetColumns = d1.data
        this.existingContents = d2.data
        this.freeInputs = {}
        for (let column of this.sheetColumns) {
          let existing = this.existingContents.find((content)=>content.column == column.id)
          let seekerCustomColumn = this.seeker.custom_column.find(c => c.column === column.refer_column)

          this.freeInputs[column.id] = existing ? existing.text : ''
          column.content = seekerCustomColumn ? seekerCustomColumn.content : (existing ? existing.text : '')
        }
        this.isLoading = false
      })
    },
    getContent (column) {
      let manageColumn = this.companyColumnSetting.find((setting)=>setting.pk==column.refer_column)
      if (!manageColumn) return '不明な項目'
      if (manageColumn.template_type == 0) {
        // カスタムカラム
        let custom = this.seeker.custom_column.find((col) => col.column==manageColumn.pk)
        if (custom) return custom.content
        else return ''
      }
      else {
        // 固定カラム
        try {
          return this.mapColumnTypeToSeekerAttribute[manageColumn.template_type](this.seeker)
        }
        catch (error) {
          return ''
        }
      }
    },
    getColumnContent(column) {
      const manageColumn = this.companyColumnSetting.find(s => s.pk === column.refer_column);
      if (!manageColumn) return '';

      const custom = this.seeker.custom_column.find((col) => col.column === column.id);
      return custom ? custom.content : '';
    },
    isPulldownColumn(column) {
      if (column.refer_column === null) {
        return { isPulldown: false, is_multiline: false, type_for_custom_column: null };
      }
      
      const manageColumn = this.companyColumnSetting.find(s => s.pk === column.refer_column);
      if (!manageColumn) {
        return { isPulldown: false, is_multiline: false, type_for_custom_column: null };
      }

      if (manageColumn.template_type === 0) {
        return { 
          isPulldown: manageColumn.is_pulldown_flg === true,
          is_multiline: manageColumn.is_multiline === true,
          type_for_custom_column: manageColumn.type_for_custom_column
        };
      }
      return { isPulldown: false, is_multiline: false, type_for_custom_column: null };
    },
    saveFreeInputs () {
      // 親コンポーネントからも呼ばれる
      let updateContents = []
      for (let [key, value] of Object.entries(this.freeInputs)) {
        let content = this.existingContents.find((content) => content.column == key)
        if (content && content.text != value) {
          content.text = value
          updateContents.push(content)
        }
        else if (!content && value) {
          updateContents.push({column: key, text: value, seeker: this.seeker.id})
        }
      }
      this.isLoading = true
      this.$store.dispatch('directtalk/updateDetailSheetContents', updateContents)
      .then((d) => {
        this.isLoading = false
      })
    },
    outputPDF () {
      let addLineFeed = function (str, num) {
        // num行未満の場合は改行を追加
        return str + '\n　'.repeat(Math.max(num - str.split('\n').length, 0))
      }

      let data = {
        table: this.sheetColumns.map((column) => {
          if (column.refer_column==null) return [column.name, addLineFeed(this.freeInputs[column.id], 3)]
          else return [column.name, this.getContent(column) || '']
        }),
        title: this.selectedTemplate.name
      }
      this.$store.dispatch('directtalk/outputDetailSheet', data)
      .then((d) => {
        let element = document.createElement('a')
        let blob = new Blob([d.request.response], { type: d.headers['content-type'] })
        element.href = window.URL.createObjectURL(blob)
        element.download = this.selectedTemplate.name + ' - ' + this.seeker.name + '.pdf'
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-box {
  display: block;
  height: 100%;
  width: 100%;
  tr {
    display: table;
    width: 100%;
    td {
      padding: 8px;
      height: auto;
      min-height: 36px;
    }
  }
}
.table-th {
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.clickable {
  cursor: pointer;
  text-decoration: underline;
}
.line-feed {
  white-space: pre;
}
</style>


// WEBPACK FOOTER //
// src/components2/Manage/modal/DetailSheet.vue